import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'asiCurrency' })
export class AsiCurrency implements PipeTransform {

  constructor() {
  }

  transform(value: any, symbole: string) {
      return Number.parseFloat(value).toFixed(2) + " " + symbole;
  }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/pipe/asi-currency.pipe.ts